import React from 'react'
import AddressLookup from 'components/Lookups/Address'
import IncomeHeader from '../../IncomeHeader'
import InputBox from '../../common/InputBox'

class Rent extends React.Component {
  state = {
    frequency: this.props.income.frequency || 'yearly',
  }

  componentDidMount() {
    this.props.onChange( this.state )
  }

 onChangeAddress = (address) => {
    const { full_address } = address

    this.props.onChange({
      address: full_address
    })
  }

  handleAmount = (e) => {
    const value = e.target.value.replace(/,/g, '')
    const amount = value ? parseInt(value) : null

    this.props.onChange({ amount })
  }

  handleFrequency = (frequency) => {
    this.props.onChange({ frequency })
  }

  render() {
    const {
      address,
      amount,
      frequency,
    } = this.props.income

    const {
      iconName,
      title,
      errors
    } = this.props

    return(
      <div className='income'>
        <IncomeHeader iconName={ iconName }
                      title={ title }
        />

        <InputBox
          label='How much rent do you receive?'
          labelClass='grey'
          type='salaryAmount'
          amount={ amount }
          frequency={ frequency }
          handleAmount={ this.handleAmount }
          handleFrequency={ this.handleFrequency }
          errorMessage={ errors && errors.amount }
          inputMode='numeric'
        />

        <p className='grey smaller mb-1'>What is the address of the property</p>
        <div className="form-row">
          <div className="col-8">
            <AddressLookup
              inputGroupClass='w-100'
              placeholder='Address - e.g. 1 York Street, Sydney, NSW 2000'
              defaultValue={ address }
              onChange={ (result) => { this.onChangeAddress(result) } }
              errorMessage={ errors && errors.address }
            />
          </div>
        </div>

      </div>
    )
  }
}

export default Rent;
